"use strict";

import axios from "axios";
import {store} from "@/store";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
let contentType =  "application/x-www-form-urlencoded";

let config = {
   baseURL: store.getters.apiUrl,
   withCredentials: false,  // Axios config seçeneği — headers içinde OLMAMALI (CORS hatası yaratır)
    transformRequest: [function (data:any, headers:any) {
        // Do whatever you want to transform the data
        if(data == null){
            return data;
        }
        if(typeof data.sendJson != "undefined"){
            headers['Content-Type'] = "application/json";
            //headers.post.con("Content-Type","application/json");
            return JSON.stringify(data.data);
        }
        else if(Object.keys(data).length > 0 ){
            let formdata = new FormData();
            Object.keys(data).forEach((field)=>{
                formdata.append(field,data[field]);
            })
            return formdata;
        }else{
            return data;
        }
    }],
    headers: {
       'X-Requested-With': 'XMLHttpRequest',
       'Content-Type': contentType,
    },
};

//headers: {'X-Custom-Header': 'foobar'}
const _axios = axios.create(config);

/*

const instance = axios.create({
  baseURL: 'https://some-domain.com/api/',
  timeout: 1000,
  headers: {'X-Custom-Header': 'foobar'}
});
 */
_axios.interceptors.request.use(
  function(config) {
      // Do something before request is sent
      if(window.localStorage.hasOwnProperty("token")){
          let token = localStorage.getItem("token");
          let panelToken = localStorage.getItem("panelToken");
          config.headers['Authorization'] = 'Bearer ' + token;
          // Panel-Authorization: yalnızca gerçek bir token varsa gönder.
          // localStorage null dönerse header'a "null" string gitmesin.
          if (panelToken && panelToken !== 'null' && panelToken !== '') {
              config.headers['Panel-Authorization'] = panelToken;
          } else {
              delete config.headers['Panel-Authorization'];
          }
      } else {
          delete config.headers['Authorization'];
          delete config.headers['Panel-Authorization'];
      }
      return config;
  },
  function(error) {
      // Do something with request error
      return Promise.reject(error);
  }
);
//window.errr  = {};

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
      //console.log("error rejected",error);
      //window.errr = error;
      if(error.response && error.response.status == 401){
         // Gövde JSON değilse (ör. responseType 'blob' ile yapılan indirme
         // isteği) mesaj okunamaz; metinsiz, boş bir bildirim açılmasın.
         const mesaj = error.response.data && error.response.data.message;
         if (typeof mesaj === "string" && mesaj !== "") {
             store.commit("snackbar", mesaj);
         }
      }
      // Do something with response error
    return Promise.reject(error);
  }
);

export function AxiosPlugin<AxiosPlugOptions>(Vue: any, options?: AxiosPluginOptions): void {
  // do stuff with options
  Vue.prototype.$http = _axios;
}
export class AxiosPluginOptions {
  // add stuff
}
